const doc = [({"no":({"js":({"routes":({"front":({"users":({"forgot_password":({"reset_password":"Tilbakestille passord"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;